import Weather from "./Weather";
import Tide from "./Tide";
import "./WeatherTideCombined.scss";

const WeatherTideCombined = ({ coordinates, city, location }) => {
  return (
    <div className="banner combined-banner">
      <div className="combined-banner-inner">
        <Weather coordinates={coordinates} city={city} limit={3} />
        <Tide location={location} limit={3} showTitle={false} />
      </div>
    </div>
  );
};

export default WeatherTideCombined;
